export default "__VITE_ASSET__Bs0Yp1jw__"